import React from "react";
import { NumberFormatBase } from "react-number-format";
import { removeNonDigitsFromString } from "../../utils/basic";

const formatHour = (value) => {
  const stripped = removeNonDigitsFromString(value);

  let finalValue = stripped.slice(0, 2);
  if (stripped.length > 2) {
    finalValue += ":" + stripped.slice(2, 4);
  }
  return finalValue;
};

const TimeTextField = React.forwardRef(({ onChange, ...other }, ref) => {
  return (
    <NumberFormatBase
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.formattedValue,
          },
        });
      }}
      format={formatHour}
    />
  );
});

export default TimeTextField;
